import type { Expand } from "@pdfking/tfunc"
import { object_map } from "@pdfking/rfunc"
import { IsString } from "@pdfking/tfunc"

type ProxyResult<K extends string, T> = Expand<{
  [P in K]: { get: () => T; set: (v: T) => void }
}>

export default <K extends string, T>(
  object: Record<string, T>,
  keys: K[] | Record<string, K>
): ProxyResult<K, T> =>
  object_map(
    (v: string) => v,
    (v: string, k: string | number) => {
      const target = IsString(k) ? (k as string) : v
      return {
        get: () => object[target],
        set: (v: T) => (object[target] = v),
      }
    },
    keys as Record<string, K>
  ) as ProxyResult<K, T>
